import React, { useEffect, useState ,useContext} from "react";
import { Button, Row, Col, Radio, Tag, Spin, Table } from "antd";
import { SaveOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Paper, TextField, Box, Typography, Divider, Button as MUIButton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { URL as BASE_URL } from "../config";
import toast from "react-hot-toast";
import { LoaderContext } from "../Components/dashboard";

const themeColor = "#4B0082";

export default function SongCategoryForm() {
  const { setLoading } = useContext(LoaderContext);
  const { id } = useParams();
  const navigate = useNavigate();


  const [saving, setSaving] = useState(false);
  const [mode, setMode] = useState(id ? "edit" : "create");

  const [categoryName, setCategoryName] = useState("");
  const [mainTypes, setMainTypes] = useState([]);
  const [fkMainTypeId, setFkMainTypeId] = useState(null);
  const [selectedMainType, setSelectedMainType] = useState(null);

  const [subTypes, setSubTypes] = useState([]);
  const [fkSubTypeId, setFkSubTypeId] = useState(null);
  const [selectedSubType, setSelectedSubType] = useState(null);
const [removeImage, setRemoveImage] = useState(0);

  const [isActive, setIsActive] = useState(1);
  const [photoFile, setPhotoFile] = useState(null);
  const [preview, setPreview] = useState("");
useEffect(() => {
  let isMounted = true;
  const startTime = Date.now();

  setLoading(true); 

  const init = async () => {
    if (id) {
      await fetchDetails(); 
    }

    const elapsed = Date.now() - startTime;
    const remaining = 1500 - elapsed;

    setTimeout(() => {
      if (isMounted) {
        setLoading(false); 
      }
    }, remaining > 0 ? remaining : 0);
  };

  init();

  return () => {
    isMounted = false;
  };
}, [id]);
 
  useEffect(() => {
    fetchMainTypes();
  }, []);

  const fetchMainTypes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/songmaintype`);
      const activeMainTypes = res.data.data.filter(i => i.isActive === 1);
      setMainTypes(activeMainTypes);

      if (id) fetchDetails(activeMainTypes); 
    } catch {
      toast.error("Failed to load main types");
    }
  };


  const fetchSubTypesByMainType = async (mainTypeId) => {
    try {
      const res = await axios.get(`${BASE_URL}/songsubtype`);
      const filtered = res.data.data.filter(
        (s) => s.fkMainTypeId === mainTypeId && s.isActive === 1
      );
      setSubTypes(filtered);
    } catch {
      setSubTypes([]);
    }
  };

  const fetchDetails = async (mainTypesList=[]) => {
    try {
     
      const res = await axios.get(`${BASE_URL}/songcategory/${id}`);
      const d = res.data.data;

      setCategoryName(d.categoryName || "");
      setFkMainTypeId(d.fkMainTypeId || null);
      setFkSubTypeId(d.fkSubTypeId || null);
      setIsActive(d.isActive ?? 1);

      const mainTypeObj = mainTypesList.find(m => m.mainTypeId === d.fkMainTypeId) || null;
      setSelectedMainType(mainTypeObj);

      if (d.fkMainTypeId) {
        await fetchSubTypesByMainType(d.fkMainTypeId);
      }

      if (d.fkSubTypeId) {
        const subTypeObj = d.fkMainTypeId 
          ? (await axios.get(`${BASE_URL}/songsubtype`)).data.data
              .find(s => s.subTypeId === d.fkSubTypeId)
          : null;
        setSelectedSubType(subTypeObj || null);
      }

      if (d.categoryPhoto) {
        setPreview(`${BASE_URL}${d.categoryPhoto}`);
      }
    } catch {
      toast.error("Failed to load category");
    } finally {
     
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };
 const removeFile = () => {
  setPhotoFile(null);
  setPreview("");
  setRemoveImage(1); 
};


  
  const clearForm = () => {
    setCategoryName("");
    setFkMainTypeId(null);
    setSelectedMainType(null);
    setFkSubTypeId(null);
    setSelectedSubType(null);
    setSubTypes([]);
    setIsActive(1);
    setPhotoFile(null);
    setPreview("");
  };

  
  const handleSave = async () => {
  if (saving) return;

  try {
    setSaving(true);

    const fd = new FormData();

    fd.append("categoryName", categoryName || "");
    fd.append("fkMainTypeId", fkMainTypeId || "");
    fd.append("fkSubTypeId", fkSubTypeId || "");
    fd.append("isActive", isActive ?? false);

    if (photoFile) {
      fd.append("categoryPhoto", photoFile);
    }

    if (removeImage === 1) {
  fd.append("removeImage", "1");
}

    if (mode === "edit") {
      await axios.patch(`${BASE_URL}/songcategory/${id}`, fd);
      toast.success("Updated successfully");
      clearForm();
      window.history.replaceState({}, "", "/dashboard/category");
      setMode("create");
    } else {
      await axios.post(`${BASE_URL}/songcategory`, fd);
      toast.success("Created successfully");
      clearForm();
    }
  } catch (err) {
    toast.error("Save failed");
    console.error(err);
  } finally {
    setSaving(false);
  }
};


  return (
    <Box sx={{  p: { xs: 0.1, md: 1 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1, md: 3 }, borderRadius: 3 }}>
      
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
           sx={{
              background: `linear-gradient(90deg, ${themeColor}, #aa46f1)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)"

            }}
          >
            <Typography
                        sx={{
                fontSize: { xs: "14px", md: "18px" },
                fontWeight: 900,
                color: "#fff",
                letterSpacing: "0.7px",
                textTransform: "uppercase",
              }}
                       >
                         Song Category
                       </Typography>
          </Box>
        </Box>

        <Divider sx={{
            mb: { xs: 2, md: 3 },
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
            borderRadius: 5,
          }}/>

       
        <Row gutter={[16,16]}>
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>Category Name</Typography>
            <TextField size="small" fullWidth value={categoryName} onChange={(e)=>setCategoryName(e.target.value)}
                      sx={{
  "& .MuiOutlinedInput-root": {
    minHeight: 40,               
    "& fieldset": { borderColor: "#ccc" },
    "&:hover fieldset": { borderColor: "#aaa" },
    "&.Mui-focused fieldset": { borderColor: "#aaa" },
  },

  "& .MuiInputBase-input": {
    fontSize: "13px",              
    padding: "8.5px 12px",         
    boxSizing: "border-box",
  },
}}
                />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>Main Type</Typography>
            <Autocomplete
              options={mainTypes}
              getOptionLabel={(o)=>o.mainTypeName||""}
              value={selectedMainType}
               ListboxProps={{
    sx: {
      maxHeight: 180,
      overflowY: "auto",
      fontSize: "13px",

      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#bbb",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    },
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      minHeight: 40,                
      "& fieldset": { borderColor: "#ccc" },
      "&:hover fieldset": { borderColor: "#aaa" },
      "&.Mui-focused fieldset": { borderColor: "#aaa" },
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      padding: "8.5px 12px",        
    },
  }}
              onChange={(e,v)=>{
                setSelectedMainType(v);
                if(v){
                  setFkMainTypeId(v.mainTypeId);
                  fetchSubTypesByMainType(v.mainTypeId);
                } else {
                  setFkMainTypeId(null);
                  setSubTypes([]);
                  setFkSubTypeId(null);
                  setSelectedSubType(null);
                }
              }}
              renderInput={(params)=><TextField {...params} size="small" placeholder="Select main type"/>}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>Sub Type</Typography>
            <Autocomplete
              options={subTypes}
              getOptionLabel={(o)=>o.subTypeName||""}
              value={selectedSubType}
              onChange={(e,v)=>{
                setSelectedSubType(v);
                setFkSubTypeId(v ? v.subTypeId : null);
              }}
               ListboxProps={{
    sx: {
      maxHeight: 180,
      overflowY: "auto",
      fontSize: "13px",

      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#bbb",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    },
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      minHeight: 40,                
      "& fieldset": { borderColor: "#ccc" },
      "&:hover fieldset": { borderColor: "#aaa" },
      "&.Mui-focused fieldset": { borderColor: "#aaa" },
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      padding: "8.5px 12px",        
    },
  }}
              renderInput={(params)=><TextField {...params} size="small" placeholder={subTypes.length===0?"No sub types available":"Select sub type"}/>}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>Status</Typography>
            <Radio.Group value={isActive} onChange={(e)=>setIsActive(e.target.value)}>
              <Radio value={1}><Tag color="green">Active</Tag></Radio>
              <Radio value={0}><Tag color="red">Deactive</Tag></Radio>
            </Radio.Group>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>Upload Photo</Typography>
            <Box display="flex" alignItems="center" gap={1.5}>
              <input hidden id="cat-photo" type="file" accept="image/*" onChange={handleFileChange}/>
              <label htmlFor="cat-photo">
                <MUIButton variant="outlined" component="span"
                sx={{ fontWeight: 600, fontSize: { xs: "12px", md: "14px" }, borderColor: "#aaa", color: "#8b8989", "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" } }}
                >Upload Photo</MUIButton>
              </label>
              {preview && <Box position="relative">
                <img src={preview} alt="preview" style={{width:50,height:50,borderRadius:6,objectFit:"cover",border:`1px solid ${themeColor}`}}/>
                <CloseIcon onClick={removeFile} sx={{position:"absolute",top:-6,right:-6,cursor:"pointer",background:"#fff",borderRadius:"50%",fontSize:16,color:themeColor}}/>
              </Box>}
            </Box>
          </Col>
        </Row>

        <Box display="flex" justifyContent="end" mt={4} gap={1.5}>
          <Button icon={<SaveOutlined/>} type="primary" onClick={handleSave}  loading={saving}          // 🔄 spinner
  disabled={saving}style={{background:themeColor,borderRadius:25}}>
            {mode==="edit"?"Update":"Save"}
          </Button>
          <Button icon={<InfoCircleOutlined/>} onClick={()=>navigate("/dashboard/categorylist")} 
                   style={{
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13
              ,color:"red",borderColor:"red"
            }}
            onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#ffe6e9";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "transparent";
  }}>
            Details
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
